export default __webpack_public_path__ + "static/media/pic3.fc207848.jpg";